import React from "react";
import "../../assets/css/style.css";
import "./CSS/GoldGlitter.css";
import "./CSS/Medias.css";
import InvitationText3L from "../InvitationText3L";

class GoldGlitter extends React.Component {
  constructor(props) {
    super(props);
    this.sakura = props.isSakura;
    this.requestLine1 = props.reqObject.requestLine1;
    this.requestLine2 = props.reqObject.requestLine2;
    this.womanName = props.reqObject.womanName;
    this.manName = props.reqObject.manName;
    this.day = props.reqObject.day;
    this.date = props.reqObject.date;
    this.year = props.reqObject.year;
    this.time = props.reqObject.time;
    this.venue = props.reqObject.venue;
    this.venueForMaps = this.venue.split(' ').join('+');
    this.venueAddress = props.reqObject.venueAddress;
    this.cityState = props.reqObject.cityState;
    this.phone = props.reqObject.phone;
    this.footerMessage1 = props.reqObject.footerMessage1;
    this.footerMessage2 = props.reqObject.footerMessage2;
    this.footerMessage3 = props.reqObject.footerMessage3;
    this.endingNote = props.reqObject.endingNote;
    this.link = `https://www.google.com/maps/search/?api=1&query=${this.venueForMaps}`;
    this.myRef = React.createRef();
    this.changed = props.reqObject.changed;
    this.baseSong = props.reqObject.baseSong;
    this.isSideBySide = props.isSideBySide;
    this.reqObject=props.reqObject;
    this.handleReqObject=props.handleReqObject;
  }
  
  render() {
    var bodyStyle = this.isSideBySide? "body-style-regular-baby":"body-style-goldGlitter-baby";
   
    return (
      <div id="fullCard" className={bodyStyle}>
        <div >
          <img alt="..." src={require('../../assets/img/GoldGlitter/top.png')} className="top-decoration-goldGlitter"/>
          <InvitationText3L reqObject={this.props.reqObject} handleReqObject={this.handleReqObject} isSakura={this.isSakura}  />
        </div>
        <img alt="..." src={require('../../assets/img/GoldGlitter/bottom.png')} className="bottom-decoration-goldGlitter"/>
      </div>
    );
  }
}

export default GoldGlitter;